export const contract ="服务协议\n" +
"   \n" +
"猎户星数据采集平台《服务协议》内容涉及《用户协议》与《隐私协议》，以下将服务协议简称为“本协议”，是您（以下也会使用“用户”来指代您）与南京摄星智能科技有限公司（以下简称“摄星智能”）就使用“猎户星”数据采集平台达成的协议。在您使用本产品之前，请务必认真阅读并充分理解本协议，未成年人应在监护人陪同下阅读和理解本协议。\n" +
"\n" +
"除非您完全接受本协议的内容，否则您无权使用猎户星数据采集平台。\n" +
"\n" +
"注册须知：\n" +
"\n" +
"请审慎阅读以下条款，如您选择“同意”按钮即表明您已详尽阅读，充分理解并同意本协议各条款所述全部内容。本协议生效后摄星智能有权根据需要修订本协议各条款，本协议一经正式公布即为生效。若您注册使用摄星提供的服务，视为对修订后的协议予以接受。如您不接受本协议的任一条款，您应选择“不同意”按钮退出注册页面；如已成为注册用户，请立即联系管理员取消注册并主动停止使用本协议项下之所有服务。\n" +
"\n" +
"\n" +
"一、用户协议\n" +
"\n" +
"1.1概述\n" +
"\n" +
"本协议适用范围\n" +
"\n" +
"本协议是猎户星数据采集平台（以下简称为“本平台”）提供者摄星智能，与用户共同缔结的对双方具有约束力的有效契约。\n" +
"\n" +
"1.2服务内容\n" +
"\n" +
"猎户星数据采集服务是指您通过本平台获取由摄星智能提供的数据采集服务。\n" +
"\n" +
"1.3关于平台\n" +
"\n" +
"地址获取\n" +
"\n" +
"您可从摄星智能官方渠道获取或由摄星智能授权的第三方获取本软件。\n" +
"\n" +
"平台更新\n" +
"\n" +
"猎户星不断努力开发新的服务，并为您不时提供软件更新，为了保证软件的安全性和功能的一致性，猎户星有权不向您特别通知而对软件进行更新，或者对平台的部分功能效果进行改变或限制。猎户星不保证旧版本软件可持续正常使用，请您及时按平台提示过渡到最新版本。\n" +
"\n" +
"1.4用户资格\n" +
"\n" +
"您作为用户，无论您是个人或组织，在注册、登录、使用、浏览、获取本协议项下的服务时，您应当具备中华人民共和国法律规定的完全民事行为能力。若您是未成年人或限制民事行为能力人，则您不具备本协议之主体资格，您及您的监护人应承担因您的不当使用行为而导致的一切后果，且猎户星及摄星智能有权向您及您的监护人索偿。\n" +
"\n" +
"1.5您的义务\n" +
"\n" +
"您保证使用本服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，不会利用本平台及服务进行发布、传播含有如下信息和内容：违反国家法律法规政策的任何内容（信息）；违反国家规定的政治宣传和或新闻信息；涉及国家秘密和或安全的信息；封建迷信和或淫秽、色情、下流的信息或教唆犯罪的信息；博彩有奖、赌博游戏；违反国家民族和宗教政策的信息；妨碍互联网运行安全的信息；侵害他人合法权益的信息和或其他有损于社会秩序、社会治安、公共道德的信息或内容。同时您须承诺不得为他人发布上述不符合国家规定和或本协议约定的信息内容提供任何便利。您理解并同意本公司有权在您违反上述约定时终止提供服务，若您上述行为给猎户星造成损失的，您承担全部赔偿责任。\n" +
"\n" +
"您须对自己在本平台的言论和行为承担法律责任。若您未遵守以上规定的，猎户星有权作出独立判断并采取暂停或关闭用户账号等措施。\n" +
"\n" +
"您必须自行准备如下设备和承担如下开支：\n" +
"\n" +
"上网开支：包括并不限于网络接入费、上网设备租用费、手机流量费等；\n" +
"\n" +
"\n" +
"二、隐私政策\n" +
"\n" +
"猎户星非常重视用户隐私政策并严格遵守相关的法律规定。请您仔细阅读后再继续使用。如果您继续使用我们的服务，表示您已经充分阅读和理解我们协议的全部内容。\n" +
"\n" +
"猎户星尊重并保护所有用户的个人隐私权。为了给您提供更准确、更优质的服务，猎户星会按照本隐私政策的规定使用和披露您的信息。猎户星会不时更新本隐私政策。您在同意猎户星服务协议之时，即视为您已经同意本隐私政策全部内容。\n" +
"\n" +
"猎户星提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法正常享受猎户星提供的功能及服务。\n" +
"\n" +
"2.1您提供的信息：\n" +
"\n" +
"您通过使用本软件服务进行相关业务操作时，以及您使用本平台及服务时所储存的信息。\n" +
"\n" +
"平台认证或平台软件升级时，猎户星可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法正常享受本平台功能及服务。\n" +
"\n" +
"2.2您使用猎户星时我们可能收集如下信息：\n" +
"\n" +
"1）您通过使用本软件服务进行相关业务操作时，以及您使用本平台及服务时所储存的信息。\n" +
"\n" +
"2）日志信息，指您使用本平台服务时，系统可能会通过一定方式自动采集的技术信息，包括：设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码；\n" +
"\n" +
"2.3猎户星获取信息后向您提供服务：\n" +
"\n" +
"1）在猎户星提供服务时，用于客户服务、安全防范、诈骗监测、存档和备份用途，确保向您提供的产品和服务的安全性；\n" +
"\n" +
"2）更加了解您如何接入和使用本平台及服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用本软件及服务的用户作出其他方面的回应；\n" +
"\n" +
"2.4猎户星如何访问和控制您的信息：\n" +
"\n" +
"猎户星将尽量采取适当的技术手段，保证您可以访问、更新和更正您的注册信息或使用本平台及服务时提供的其他个人信息。在访问、更新、更正和删除您的个人信息时，猎户星可能会要求您进行身份验证，以保障您的账户安全。\n" +
"\n" +
"如猎户星或猎户星关联公司需与第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。\n" +
"\n" +
"猎户星或猎户星的关联公司还可能为以下需要保留、保存或披露您的个人信息：\n" +
"\n" +
"（1）遵守适用的法律法规；\n" +
"\n" +
"（2）遵守法院命令或其他法律程序的规定；\n" +
"\n" +
"（3）遵守相关政府机关的要求；\n" +
"\n" +
"（4）我们认为遵守适用的法律法规、维护社会公共利益，或保护我们、我们的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需的。\n" +
"\n" +
"2.5猎户星如何保留、储存和保护您的信息\n" +
"\n" +
"猎户星仅在本《服务协议》所述目的所必需期间和法律法规要求的时限内保留您的个人信息。\n" +
"\n" +
"猎户星使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。但请您谅解，由于技术的限制以及风险防范的局限，即便猎户星已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您使用本平台及服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。\n" +
"\n" +
"2.6本平台中的第三方服务\n" +
"\n" +
"本平台可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。第三方社交媒体或其他服务可能由相关的第三方运营。您使用第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受第三方自己的服务条款及隐私政策（而非本《猎户星数据采集平台服务协议》）约束，您需要仔细阅读其条款。本《猎户星数据采集平台服务协议》仅适用于猎户星所收集的任何信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，而猎户星及摄星智能对任何第三方使用由您提供的信息不承担任何责任。\n" +
"\n" +
"三、知识产权\n" +
"\n" +
"本平台提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，猎户星及摄星智能享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。未经权利人书面同意，您不得将上述资料在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行,或者被用于其他任何商业目的。所有以上资料或资料的任何部分仅可作为私人和非商业用途保存。\n" +
"\n" +
"四、猎户星免责声明\n" +
"\n" +
"4.1一切用户在注册成本软件用户时均被视为已经仔细阅读并完全同意。凡以任何方式登录本软件，直接或间接使用本软件资料者，均被视为自愿接受本平台《服务协议》的约束。\n" +
"\n" +
"4.2用户转载及发布的文字、图片、音视频等资料内容并不代表本软件之意见及观点，也不以为着本软件赞同其观点或证实其内容的真实性，如果侵犯了第三方知识产权或其他权利，责任由用户本人承担，猎户星及摄星智能对此不承担责任。\n" +
"\n" +
"4.3除本软件注明服务条款外，其他因不当使用使用而导致的任何意外、疏忽、诽谤、版权和其他知识产权侵犯及其造成的任何损失，猎户星及摄星智能概不负责，亦不承担任何法律责任。\n" +
"\n" +
"4.4对于因不可抗力或黑客攻击、通讯路线中断等猎户星及摄星智能不能控制的原因造成的网络服务中断或其他缺陷，导致用户不能正常使用本软件，猎户星及摄星智能不承担任何责任，但将尽力减少因此给用户造成的损失和影响。\n" +
"\n" +
"4.5本网站相关声明版权及修改权、更新权和解释权均属猎户星及摄星智能所有。\n" +
"\n" +
"4.6本声明未涉及的问题请参见国家有关法律法规。\n" +
"\n" +
"五、隐私政策的变更\n" +
"\n" +
"如果决定更改隐私政策，我们会在本政策中、本公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。您可以通过登录蜂鸟导播平台，随时查看我们的《服务协议》。\n" +
"\n" +
"六、联系我们\n" +
"\n" +
"您在使用猎户星的过程中，如果对本《服务协议》有任何的疑义或建议，或您认为您的个人信息没有得到本《服务协议》规定的保护，您可以通过以下方式联系我们，猎户星将真诚地处理您的投诉及建议。\n" +
"\n" +
"地址：北京市海淀区静芯园大厦G座\n" +
"电话：\n" +
"\n" +
"请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄露，尤其是用户名及密码发生泄露，请您立即联络客服，以便采取相应措施。\n" +
"\n" +
"感谢您花时间了解我们的服务协议！我们将尽全力保护您的个人信息和合法权益，再次感谢您的信任！\n" +
"\n" +
"本平台运营主体名称：南京摄星智能科技有限公司";